/* eslint-disable jsx-a11y/no-redundant-roles */
import React from 'react';
import PropTypes from 'prop-types';
import CybsButton from '@cybs-ui/components/lib/button';
import { StructFlex } from '@cybs-ui/components/lib/struct-flex';
import CybsStatusBadge from '@cybs-ui/components/lib/status-badge';

import Icon from '@visa/vds-react/icon-styled';
import classes from './left.styles';
import CollapsibleButton from './collapsible-button';


const LeftActionBar = ({
  actionBarId,
  isInvalid,
  leftActions,
  headingLevel,
  i18n,
  statusBadge,
  collapsible,
  dataTest,
  normalTitleSize
}) => {
  const actionCheck = action => {
    if (action instanceof Element) {
      return action;
    }
    return action && <CybsButton dataTest="button-left" {...action} />;
  };
  const getWrapperClass = cssInput =>
    classes(cssInput.classes, cssInput.variables, cssInput.cybs).wrapperDiv;
  const getLeftTitleClass = cssInput =>
    classes(cssInput.classes, cssInput.variables, cssInput.cybs).leftTitle;
  const getSubtitleClass = cssInput =>
    classes(cssInput.classes, cssInput.variables, cssInput.cybs).subtitle;
  const getAdditionalSubtitleClass = cssInput =>
    classes(
      cssInput.classes,
      cssInput.variables,
      cssInput.cybs,
      actionCheck(leftActions[0])
    ).additionalSubtitle;

  return (
    <StructFlex
      direction="row"
      align-items="center"
      flex-wrap="wrap"
      css={getWrapperClass}
    >
      {collapsible && collapsible.location === 'left' && (
        <CollapsibleButton
          collapsible={collapsible}
          actionBarId={actionBarId}
          i18n={i18n}
          dataTest={dataTest}
        />
      )}
      {isInvalid ? <Icon name="error" resolution="tiny" /> : ''}
      {(i18n.title && !normalTitleSize) && (
        <div css={getLeftTitleClass}>
          <h3 aria-level={headingLevel} id={actionBarId} role="heading">
            {i18n.title}
          </h3>
        </div>
      )}
      {(i18n.title && normalTitleSize === true) && (
        <div css={getLeftTitleClass}>
          <div aria-level={headingLevel} id={actionBarId} role="heading">
            {i18n.title}
          </div>
        </div>
      )}
      {i18n.subtitle && <div css={getSubtitleClass}>{i18n.subtitle}</div>}
      {actionCheck(leftActions[0])}
      {i18n.additionalSubtitle && (
        <div css={getAdditionalSubtitleClass}>{i18n.additionalSubtitle}</div>
      )}
      {actionCheck(leftActions[1])}
      {statusBadge &&
          <CybsStatusBadge
            dataTest={statusBadge.dataTest}
            label={statusBadge.label}
            status={statusBadge.status}
            icon={statusBadge.icon}
            textOnly={statusBadge.textOnly}
          />
      }
    </StructFlex>
  );
};
LeftActionBar.displayName = 'LeftActionsActionBar';

LeftActionBar.propTypes = {
  /**
   * Required data testing string
   */
  dataTest: PropTypes.string,

  /**
   * collapsible configuration
   */
  collapsible: PropTypes.shape({
    isOpen: PropTypes.bool,
    onClick: PropTypes.func,
    location: PropTypes.oneOf(['left', 'right'])
  }),
  /**
   * Generated unique id
   */
  actionBarId: PropTypes.string.isRequired,
  /**
   * Level of the heading displayed before the component
   */
  headingLevel: PropTypes.number,
  /**
   * invalid selection in action bar for grid.
   */

  isInvalid: PropTypes.bool,
  /**
   *  Actions on the left side of the bar. May pass array of button configs
   *  or a React element.
   */

  leftActions: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(
      PropTypes.shape({
        active: PropTypes.bool,
        ariaLabel: PropTypes.string,
        colorScheme: PropTypes.string,
        disabled: PropTypes.func,
        iconClass: PropTypes.string,
        iconLocation: PropTypes.string,
        href: PropTypes.string,
        label: PropTypes.string,
        onClick: PropTypes.func,
        onKeyDown: PropTypes.func,
        variant: PropTypes.string,
        statusBadge: PropTypes.object
      })
    )
  ]),
    /**
   * Status badge for the action bar.
   */
  statusBadge: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(
      PropTypes.shape({
        dataTest: PropTypes.string,
        status: PropTypes.string,
        icon: PropTypes.string,
        label: PropTypes.string,
        textOnly: PropTypes.bool
      })
    )
  ]),
  /**
   * Strings for the component.
   */
  i18n: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    additionalSubtitle: PropTypes.string
  })
};

LeftActionBar.defaultProps = {
  dataTest: '',
  collapsible: undefined,
  headingLevel: 3,
  isInvalid: false,
  leftActions: [],
  i18n: {},
  statusBadge: undefined,
  normalTitleSize: false
};
export default LeftActionBar;
